export default function ServiceHero() {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h1 className="font-sora font-bold text-6xl text-charcoal mb-6">
          Services
        </h1>
        <p className="font-inter text-xl text-gray-600 leading-relaxed">
          Everything you need to build a strong online presence and attract more customers. Clean, fast, and built to convert.
        </p>
      </div>
    </section>
  );
}